<main [attr.aria-label]="'content.terms-of-use' | translate" [innerHTML]="'content.terms-of-use-body' | translate"></main>
